<template>
  <div class="faq__item" v-if="fields && fields.heading" :class="{ open: toggleOn }">
    <div class="faq__item--title" @click="toggle">
      <sc-text tag="h4" v-if="fields && fields.heading" :field="fields.heading" />
    </div>
    <div class="faq__item--content">
      <sc-placeholder name="jss-faq-item-content" :rendering="rendering" />
    </div>
  </div>
</template>

<script>
import { Text, Placeholder } from '@sitecore-jss/sitecore-jss-vue';

export default {
  name: 'CIS-FAQ-Item',
  components: {
    ScText: Text,
    ScPlaceholder: Placeholder
  },
  props: {
    fields: {
      type: Object
    },
    rendering: {
      type: Object
    }
  },
  data: function () {
    return {
      toggleOn: false
    };
  },
  methods: {
    toggle() {
      this.toggleOn = !this.toggleOn;
    }
  }
};
</script>
<style lang="scss" scoped>
.faq {
  &__item {
    margin-bottom: 0.6rem;

    &.open {
      div {
        &:first-child {
          &:after {
            display: none;
          }
        }

        display: block;
      }
    }

    &--title {
      width: 100%;
      position: relative;
      padding: 2rem 6.5rem 2rem 2rem;
      cursor: pointer;
      background: linear-gradient(
        169deg,
        rgba(0, 0, 0, 1) 0%,
        rgba(0, 59, 92, 1) 20%,
        rgba(0, 134, 191, 1) 100%
      );
      box-shadow: 0 -0.2rem 0.5rem 0 rgba(0, 0, 0, 0.02), 0 1.8rem 1.7rem 0 rgba(0, 0, 0, 0.08),
        0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.08);

      &:before {
        content: '';
        position: absolute;
        top: 50%;
        right: 2rem;
        height: 0.14rem;
        width: 1.5rem;
        background: #ffffff;
        pointer-events: none;

        @include desktop-up {
          content: '';
          width: 2rem;
        }
      }

      &:after {
        content: '';
        position: absolute;
        top: 50%;
        right: 2.7rem;
        height: 1.5rem;
        width: 0.14rem;
        background: #ffffff;
        transform: rotate(0) translate(0, -50%);
        pointer-events: none;

        @include desktop-up {
          content: '';
          right: 2.9rem;
          height: 2rem;
        }
      }

      h4 {
        @include font-styles('Arial', 1.8rem, 300, normal, 2.4rem, 0, $white);
        margin: 0;

        @include desktop-up {
          @include font-styles('Arial', 2rem, 300, normal, 2.4rem, 0, $white);
        }
      }
    }

    &--content {
      position: relative;
      background-color: #ffffff;
      box-shadow: 0 -0.2rem 0.5rem 0 rgba(0, 0, 0, 0.02), 0 1.8rem 1.7rem 0 rgba(0, 0, 0, 0.08),
        0 0.2rem 0.4rem 0 rgba(0, 0, 0, 0.08);
      margin-top: 0.6rem;
      padding: 2rem 2rem 2.2rem 2rem;
      display: none;

      @include desktop-up {
        padding: 5rem 5rem 2.2rem 5rem;
      }

      &:deep() {
        .accordion {
          margin-bottom: 1rem;

          @include desktop-up {
            margin-bottom: 5rem;
          }
        }

        .accordion__item {
          &.open {
            background: $white;
          }
        }

        .accordion__item--title {
          padding-left: 0;
          padding-right: 3rem;

          @include desktop-up {
            padding-left: 2rem;
            padding-right: 4rem;
          }

          &:hover {
            background: $white;
          }

          &:before {
            right: 4rem;

            @include desktop-up {
              right: 5rem;
            }
          }

          h4 {
            font-size: 1.8rem;
            line-height: 2.4rem;

            @include desktop-up {
              font-size: 2rem;
              line-height: 2.4rem;
            }
          }
        }

        .accordion__item--content {
          padding-left: 0;
          padding-right: 0;

          @include desktop-up {
            padding-left: 5rem;
            padding-right: 5rem;
          }
        }
      }
    }

    &.scEnabledChrome {
      .faq__item--content {
        display: block;
      }
    }
  }
}
</style>
